export const hambergerId = "hambergerId";
export const macysLogoId = "macysLogoId";
export const userId = "userId";
export const userIconId = "userIconId";
export const userArrowId = "userArrowId";
export const macysLogoText = "macysLogoText";
export const macysHome = "macysHome";
export const vendorOnboard = "vendorOnboard";
export const deleteIconId = "deleteIconId";
